import CorrectAnswer from "./CorrectAnswer";

export default CorrectAnswer;
